<template>
	<section class="app-container">
		<div class="container record-add" v-if="!loading_user">
			<div v-if="current_user">
				<h1>Submit a Record Checklist</h1>
				<div class="row">
					<div class="col-md-6">
						<div class="form-group">
							<label>Submitted By</label>
							<strong>{{current_user.display_name}}</strong>
						</div>
					</div>
					<div class="col-md-6 text-right" v-show="!addingiNat">
						<button class="btn btn-xs" @click="iNatPopup()">Import from iNaturalist</button>
					</div>
					<div class="col-md-6" v-show="addingiNat">
						<div class="alert alert-info">
							<strong>Importing for iNatrualist record {{iNatImportID}}.</strong>
						</div>
					</div>
				</div>
				<div v-if="addingiNat && addingLocation && !iNatImportIsObscured" class="alert alert-info">
          			Please review the location information imported from iNaturalist below and edit it if necessary. After adding the location you will be asked to review the record on the next screen.<br />
          			<strong>NOTE</strong>: The location of many records is obscured by iNaturalist and the pin location may only be approximate. Please drop the pin at the accurate location.
				</div>
				<div v-if="addingiNat && addingLocation && iNatImportIsObscured" class="alert alert-warning">
          			The coordinates provided by iNaturalist for this observation are inexact.<br />
          			Please select a more exact location from the map below.<br />
          			If you do not want to give the exact location, give one no more than 2 km (1.2 miles) away in the same jurisdiction.
				</div>
				<ChecklistEditControl ref="checklistEdit" v-model="checklist" :errors="errors" :current_user="current_user" @addChanged="addChanged" @locationChanged="locationChanged" />
				<button v-if="!addingLocation" v-on:click="createChecklist" class="btn btn-block btn--primary type--uppercase">Click To Begin Entering Records</button>
			</div>
			<div v-else>
				<div class="alert">
						<div class="alert__body">
								<span>Please login to submit sightings.</span>
						</div>
				</div>
			</div>
		</div>
		<div class="modal-container inat-import-modal" id="iNatImport">
			<div class="modal-content modal-content-regular">
				<div class="modal-close modal-close-cross"></div>
				<div class="bg--white border--round ">
					<div class="container">
						<h3>Enter iNaturalist Observation ID or URL</h3>
						<p><strong>This will import the date and location from the iNaturalist record.<br />You will be able to import species information on the next page.</strong></p>
						<input ref="iNatImportInput" v-model="iNatImportID" type="text" >
						<button class="btn btn-block btn--primary" @click="iNatImport()">Import from iNaturalist</button>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import global_data from '../../main';
export default {
	name: 'ChecklistAddComponent',
	metaInfo: {
      title: 'Add Sightings',
    },
	data: function(){
		return {
			loading_user: true,
			checklist: {
				private: false,
			},
			errors: {},
			current_user: null,
			addingLocation: false,
			iNatImportID: null,
			addingiNat:false,
			iNatImportIsObscured:false,
		};
	},
	mounted: function(){
		var self = this;
		this.get_user_and_favs();
		global_data.$on("user_changed", function(user){
			self.get_user_and_favs();
		});
	},
	methods:{
		iNatImport: function(){
			var workingid = this.iNatImportID;
			if (workingid.lastIndexOf('/') > -1) {
				var wsplit = workingid.split('/');
				workingid = wsplit[wsplit.length - 1];
			}
			workingid = parseInt(workingid);
			if (isNaN(workingid) || workingid < 1) {
				this.$notify({
					text: 'Please enter a valid iNaturalist ID or URL.',
					type: 'error',
				});
				return;
			}
			mr.modals.closeActiveModal();
			var self = this;
			this.iNatAPI({
				endpoint: 'observations/' + workingid,
				funcThen: function(response){
					self.addingiNat = true;
					self.processiNatRecord(response.data.results[0]);
				},
				funcCatch: function(error){
					console.log(error);
				},
			});
		},
		processiNatRecord: function(record){
			this.iNatImportIsObscured = record.obscured;
			var dparts = record.observed_on_details.date.split('-');
			var monthIndex = parseInt(dparts[1]) - 1;
        	var date = new Date(dparts[0],monthIndex,dparts[2]);
			this.$refs.checklistEdit.setDate(date);
			var location = record.location.split(',');
			
			this.$refs.checklistEdit.setCoordinates(parseFloat(location[0]), parseFloat(location[1]), record.place_guess, this.iNatImportIsObscured);
		},
		iNatPopup: function(adding){
        	mr.modals.showModal($('#iNatImport'));
        	// this.$refs.iNatImportInput.$el.focus();
		},
		addChanged: function(adding){
			this.addingLocation = adding;
		},
		locationChanged:function(){
			// if (this.addingiNat) {
			// 	this.createChecklist();
			// }
		},
		createChecklist: function(){
			var self = this;
			this.API({
				endpoint: 'checklists',
				funcThen: function(response){
					self.$notify({
					  text: 'Please document records with photos or specimens when possible.',
					  type: 'success',
					});
					if (self.iNatImportID) {
						self.$router.push({ name: 'checklist_edit', params: { id: response.data.checklist.id }, query:{ inatrecord: self.iNatImportID } });
					}
					else{
						self.$router.push({ name: 'checklist_edit', params: { id: response.data.checklist.id } });
					}
				},
				funcCatch: function(error){
					if (error && error.response) {
						self.errors = error.response.data;
					}
				},
				isPost:true,
				postData: this.get_cleaned_checklist()
			});
		},
		get_cleaned_checklist: function(){
			var cleaned_checklist = JSON.parse(JSON.stringify(this.checklist));
			if (cleaned_checklist.has_another_observer) {
				if (cleaned_checklist.observer == null) {
					cleaned_checklist.observer = "";
				}
			}
			else{
				cleaned_checklist.observer = null;
			}
			delete cleaned_checklist.has_another_observer;
			return cleaned_checklist;
		},
		get_user_and_favs: function(){
			var self = this;
			self.GetAPIUser(function(user){
				self.current_user = user;
				self.loading_user = false;
			}, true);
		},
	},
	watch: {
	},
}
</script>


// WEBPACK FOOTER //
// src/components/pages/ChecklistAdd.vue